export default __webpack_public_path__ + "static/media/CoreUI-Icons-Linear-Free.b5c93177.eot";